import {
    app,
    ConfigPage,
    globalMatrix,
    IDropdownOption,
    ILineEditorLine, IRestResult,
    matrixsdk,
    ml,
    TestManager
} from "../../../sdk/client";
import {IPluginSettingPage} from "../../../sdk/plugins/interfaces";
import {IProjectSettings} from "./Interfaces";
import {Plugin} from "./Main";
import {LineEditorExt} from "../../../core/common/UI/ILineEditor";
import { LineType } from '../../../core/common/UI/LineType';
import {FieldDescriptions} from "../../../core/common/businesslogic/FieldDescriptions";
import {extend} from "../../../core/common/matrixlib/JQueryExtendReplacement";

export class ProjectSettingsPage extends ConfigPage
    implements IPluginSettingPage<IProjectSettings> {

    settingsOriginal: IProjectSettings;
    settingsChanged: IProjectSettings;
    getSettingsDOM(settings: IProjectSettings): JQuery {

        return $(`
            `);
    }

    settings(): IProjectSettings {
        let currentSettings = {};
        if (this.configApp != undefined && this.configApp.getJSONProjectSettings != undefined) {
            let filterSettings = this.configApp.getJSONProjectSettings(this.getProject(), Plugin.config.projectSettingsPage.settingName);
            if (filterSettings.length == 1)
                currentSettings = filterSettings[0].value;
        }
        else {
            currentSettings = globalMatrix.ItemConfig.getSettingJSON(Plugin.config.projectSettingsPage.settingName, {});
        }
        console.log("Returning project settings");
        return { ...Plugin.config.projectSettingsPage.defaultSettings, ...currentSettings }
    }
    renderSettingPage() {
        this.initPage(
            `${Plugin.config.projectSettingsPage.title}`,
            true,
            undefined,
            Plugin.config.projectSettingsPage.help,
            Plugin.config.projectSettingsPage.helpUrl,
            undefined
        );
        this.settingsOriginal =  {... this.settings()};
        this.settingsChanged = JSON.parse(JSON.stringify(this.settings())); // deep copy
        this.showSimple();
    }
    saveAsync() {
        let def = this.configApp.setProjectSettingAsync(this.getProject(), Plugin.config.projectSettingsPage.settingName, JSON.stringify(this.settingsChanged), this.configApp.getCurrentItemId());
        def.done(() => {
            this.settingsOriginal = { ...this.settingsChanged };
            this.renderSettingPage();
        })
        return def;
    }
    getProject() {
        /* get the project id from the setting page */
        return this.configApp.getCurrentItemId().split("-")[0];
    }
    showAdvanced() {
        console.debug("Show advanced clicked");
        this.showAdvancedCode(JSON.stringify(this.settingsChanged),  (newCode: string) => {
            this.settingsChanged = JSON.parse(newCode);
            this.paramChanged();
            this.showSimple();
        });
    }
    showSimple() {

        this.simple.html("");
        this.simple.append(this.getSettingsDOM(this.settingsChanged));
        this.showWarning("We recommend that you make a copy of this setting (through advanced button) before modifying it.");

        this.showQueries();
        this.showSearchExpressions();

        $("<h1>").html("Options").appendTo(this.simple);

        this.showOtherFields();
        this.showIncludeTaskInTestTable();



        app.itemForm.append(this.simple);




    }
    protected showIncludeTaskInTestTable() {
        if (this.settingsChanged.includeTasksInTable != undefined) {
            let div = $("<div>");
            ml.UI.addCheckboxIsTrue(div, "Show tasks in TEO table by default", this.settingsChanged, "includeTasksInTable", () => {
                console.log(this.settingsChanged);
                this.paramChanged();

            });
            this.simple.append(div);
        }

    }

    showOtherFields() {
        let div = $("<div>");
        let xtcFields = globalMatrix.ItemConfig.getFields("XTC")??[];
        let options = xtcFields.filter(f => [FieldDescriptions.Field_steplist,FieldDescriptions.Field_test_steps_result,
            FieldDescriptions.Field_test_result,FieldDescriptions.Field_richtext,
            FieldDescriptions.Field_htmlForm,FieldDescriptions.Field_labels,
            FieldDescriptions.Field_checkbox]
            .indexOf(f.fieldType) == -1).map(f => { return <IDropdownOption>{ id: f.label, label: f.label } });

             ml.UI.addDropdownToArray(div, "Select optional fields for stats", this.settingsChanged, "otherFields", options, [] , 10, false, false, () => {

            console.log(this.settingsChanged);
            this.paramChanged();

        });
        this.simple.append(div);

    }

    protected createEditQuery(idx: number) {

        let input: ILineEditorLine[] = [
            { help: " name", type:LineType.textline, value: (idx >= 0) ? this.settingsChanged.testResultQueries[idx].displayString : "", required: true },
            { help: "expression", type:LineType.textline, value: (idx >= 0) ? decodeURI(this.settingsChanged.testResultQueries[idx].mrqlPart) : "", required: true },
            { help: "color", type: LineType.color, value: (idx >= 0) ? this.settingsChanged.testResultQueries[idx].color : "", required: true }
        ];
        let le = new LineEditorExt();
        le.showDialog((idx >= 0) ? "Edit query" : "Define new query", 400, input,  (update: ILineEditorLine[])  => {

            if (!update[0].value) {
                alert("please provide a name");
                return false;
            }

            if (!update[1].value) {
                alert("please provide a search expression");
                return false;
            }
            if (!update[2].value) {
                alert("please provide a color");
                return false;
            }
            if (idx > -1) {
                this.settingsChanged.testResultQueries[idx].displayString = update[0].value;
                this.settingsChanged.testResultQueries[idx].mrqlPart =  update[1].value;
                this.settingsChanged.testResultQueries[idx].color = update[2].value;
            } else {
                this.settingsChanged.testResultQueries.push({ displayString: update[0].value, mrqlPart: update[1].value, color: update[2].value });
            }
            this.paramChanged();
            this.showQueries();
            return true;
        });
    }


    protected showQueries() {

        let container = $("#queriesContainer");
        if (container.length == 0) {
            container = $("<div id='queriesContainer'>");
            this.simple.append(container);

        }
        container.html("");

        if (this.settingsChanged.testResultQueries != undefined) {

            $("#teoQueriesTitle").remove();
            $("<h1 id='teoQueriesTitle' >").html("Queries").appendTo(container);
            $("#teoQueries").remove();
            let ul = $("<ul id='teoQueries'>");

            for (const testResultQuery of this.settingsChanged.testResultQueries) {
                const idx = this.settingsChanged.testResultQueries.indexOf(testResultQuery);
                let li = $("<li>").appendTo(ul);
                li.append($("<span>").html("<i class='fa fa-square'   style='margin-right:10px;color:" + testResultQuery.color + "''></i> <b>" + testResultQuery.displayString + ": </b>" + decodeURI(testResultQuery.mrqlPart)));
                // add edit button
                let edit = $("<span class='editLinkButton'>").html("edit").data("idx", idx).click( (event) => {
                    let editIdx = $(event.delegateTarget).data("idx");
                    this.createEditQuery(editIdx);
                });
                li.append(edit);
                // add delete button
                let deletebtn = $("<span class='editLinkButton'>").html("delete").data("idx", idx).click( (event) =>{
                    let editIdx = $(event.delegateTarget).data("idx");
                    this.settingsChanged.testResultQueries.splice(editIdx, 1);
                    this.showQueries();
                    this.paramChanged();
                });
                li.append(deletebtn);

            }

            container.append(ul);
            $("<span class='editLinkButton'>").html("create new query").click( (event)=> {

                this.createEditQuery(-1);
            }).appendTo(container);
        }

    }



    protected showSearchExpressions() {


        $("<h1>").html("Auto-generated queries ").appendTo(this.simple);
        let tm: TestManager = matrixsdk.getTestManager();
        tm.InitializeProject();

        $("<div>").html("<b>New:</b>" + tm.getSearchExpression("new", false)).appendTo(this.simple);
        $("<div>").html("<b>In Progress:</b>  " + tm.getSearchExpression("progress", false)).appendTo(this.simple);
        $("<div>").html("<b>Passed:</b>  " + tm.getSearchExpression("ok", false)).appendTo(this.simple);
        $("<div>").html("<b>Failed:</b> " + tm.getSearchExpression("error", false)).appendTo(this.simple);
    }


    paramChanged() {
        this.configApp.itemChanged(JSON.stringify(this.settingsOriginal) != JSON.stringify(this.settingsChanged));
    }
}
